"use client";

import { faChevronRight, faUser } from "@fortawesome/pro-solid-svg-icons";
import { Button, SideDialog, useModal } from "@tosize/ui";
import { usePathname } from "next/navigation";
import { Fragment, type PropsWithChildren, useEffect } from "react";

interface CustomerDialogProps extends PropsWithChildren {
	title: string;
	anchorTitle?: string;
	variant?: "accountMenu" | "cart" | "checkout";
}

export function CustomerDialog({ children, title, anchorTitle, variant }: CustomerDialogProps) {
	const dialog = useModal();
	const pathName = usePathname();

	// biome-ignore lint/correctness/useExhaustiveDependencies: dialog.close cannot be added to the dependency array, because it will cause an infinite loop
	useEffect(() => {
		if (pathName) dialog.close();
	}, [pathName]);

	return (
		<Fragment>
			<Button
				variant="link"
				color={variant === "cart" ? "white" : "primary-medium"}
				onClick={dialog.toggle}
				className="ixtems-center whitespace-nowrap"
				starticon={
					variant === "accountMenu" ? faChevronRight : variant === "cart" ? faUser : undefined
				}
				endicon={variant === "checkout" ? faUser : undefined}
			>
				{anchorTitle}
			</Button>

			<SideDialog title={title} size="sm" color="shades-light" {...dialog.props}>
				{children}
			</SideDialog>
		</Fragment>
	);
}
